<template>
  <div class="container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="col-md-8 offset-md-2">
            <h5 class="card-title">Agregar nueva empresa</h5>
            <b-form @submit.stop.prevent="onSubmit">
              <b-form-group label-cols-sm="2" label="Sucursal*" label-for="input-enterprise">
                <b-form-input
                  id="input-enterprise"
                  name="input-enterprise"
                  type="text"
                  v-model="$v.form.enterprise.$model"
                  :state="validateState('enterprise')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-enterprise-live-feedback"
                >La Empresa o Sucursal es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Dirección*" label-for="input-address">
                <b-form-input
                  id="input-address"
                  name="input-address"
                  type="text"
                  v-model="$v.form.address.$model"
                  :state="validateState('address')"
                ></b-form-input>
                <b-form-invalid-feedback id="input-address-live-feedback">La Dirección es requerida.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Estado*" label-for="input-state">
                <multiselect
                  v-model="stateObject"
                  :options="mexicosStatesList"
                  :searchable="true"
                  :close-on-select="true"
                  :allow-empty="false"
                  :show-labels="false"
                  placeholder="Estado"
                  track-by="name"
                  label="name"
                  required
                />
                <b-form-invalid-feedback id="input-state-live-feedback">El estado es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Ciudad*" label-for="input-city">
                <multiselect
                  v-model="cityObject"
                  :options="mexicoCitiesList"
                  :searchable="true"
                  :close-on-select="true"
                  :allow-empty="false"
                  :show-labels="false"
                  placeholder="Ciudad"
                  track-by="name"
                  label="name"
                  required
                />
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Teléfono" label-for="input-phone_number">
                <b-form-input
                  id="input-phone_number"
                  name="input-phone_number"
                  type="text"
                  v-model="$v.form.phone_number.$model"
                  :state="validateState('phone_number')"
                ></b-form-input>
              </b-form-group>

              <div class="form-group row mt-5">
                <div class="col-sm-12">
                  <b-button type="submit" variant="primary" block>Agregar Empresa</b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import mexicosStatesList from '@/mixins/mexicosStatesList'
import mexicoCitiesList from '@/mixins/mexicoCitiesList'
import { validationMixin } from 'vuelidate'
import formatData from '@/mixins/formatAxios'
import { required } from 'vuelidate/lib/validators'
import {
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  // BFormSelect,
  BFormInvalidFeedback
} from 'bootstrap-vue'

export default {
  mixins: [validationMixin, formatData],
  components: {
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback
    // BFormSelect
  },
  data () {
    return {
      form: {
        enterprise: '',
        address: '',
        phone_number: ''
      },
      stateObject: { name: '', code: '' },
      cityObject: { name: '', id: '' },
      mexicosStatesList: mexicosStatesList,
      mexicoCitiesList: mexicoCitiesList
    }
  },
  validations: {
    form: {
      enterprise: {
        required
      },
      address: {
        required
      },
      phone_number: {}
    }
  },
  methods: {
    showError (msg) {
      this.$toastedPush({
        message: msg,
        type: 'error'
      })
    },
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async onSubmit () {
      try {
        console.log('entro aca')
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }
        const request = {
          name: this.form.enterprise,
          address: this.form.address,
          state: this.stateObject.name,
          city: this.cityObject.name,
          phone: this.form.phone_number
        }
        const response = await axiosAdelaService.post('/addEnterprise', request)
        console.log(response)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Se agrego sucursal correctamente.',
            type: 'success'
          })
          this.$router.push({ name: 'enterprises' })
        }
      } catch (error) {
        this.showError('No se pudo agregar la empresa, intentalo mas tarde')
      }
    }
  },
  computed: {
    state: function () {
      return this.stateObject.name
    },
    city: function () {
      return this.cityObject.name
    }
  },
  watch: {
    state (state) {
      this.mexicoCitiesList = this.$_.filter(mexicoCitiesList, ['stateId', this.stateObject.id])
    }
  }
}
</script>

<style>

</style>
